import { render, staticRenderFns } from "./actionInterest.vue?vue&type=template&id=36167138&scoped=true"
import script from "./actionInterest.vue?vue&type=script&lang=js"
export * from "./actionInterest.vue?vue&type=script&lang=js"
import style0 from "./actionInterest.vue?vue&type=style&index=0&id=36167138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36167138",
  null
  
)

export default component.exports